module.exports = __webpack_public_path__ + "img/70_11.f114d0d9.png";